import * as React from 'react'
import * as R from 'ramda'
import * as Editable from '../../../Data/Editable'
import {PositionRow, PositionsTab} from './PositionsState'
import {PositionsSubAction} from './PositionActions'
import Table from 'material-ui-next/Table/Table'
import TableHead from 'material-ui-next/Table/TableHead'
import TableRow from 'material-ui-next/Table/TableRow'
import TableBody from 'material-ui-next/Table/TableBody'
import TableCell from 'material-ui-next/Table/TableCell'
import {TableCellGrayOutOverlay} from '../../../View/TableCellGrayOutOverlay'
import FlatButton from 'material-ui/FlatButton'
import ImagePictureAsPdf from 'material-ui/svg-icons/image/picture-as-pdf'
import CircularProgress from 'material-ui/CircularProgress'
import AlertError from 'material-ui/svg-icons/alert/error'
import {EditableFloatingActionButtons} from '../../../View/EditableFloatingActionButtons'
import IconButton from 'material-ui/IconButton'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import ContentUndo from 'material-ui/svg-icons/content/undo'
import {ProductCategory} from '../../../Entities/ProductCategory'
import ContentAddBox from 'material-ui/svg-icons/content/add-box'
import {ProductFinderView} from '../../../Components/ProductFinder/ProductFinderView'
import {errorMessage} from '../../../Data/FormValidation'
import {CisTableCell} from '../../../View/CisTableCell'
import {EditableTextField} from '../../../View/EditableTextField'
import injectSheet from 'react-jss'
import {card, tabs} from '../../../Style'

const styles = {
    ...tabs,
    ...card
}

interface PropsPositionsTabView {
    readonly active: boolean
    readonly state: PositionsTab
    readonly dispatch: (action: PositionsSubAction) => void
}

export const PositionsTabView =
    injectSheet<PropsPositionsTabView>(styles)(
        ({classes, state, dispatch, active}) => (
            <div className={classes.tabsContent} style={{padding: '40px'}}>
                {state.productFinder !== null &&
                <ProductFinderView
                    state={state.productFinder}
                    dispatch={
                        subAction => dispatch({
                            type: 'ProductFinderModuleAction',
                            subAction,
                        })
                    }
                />
                }
                {active &&
                <EditableFloatingActionButtons
                    editable={state.editable}
                    onEdit={() => dispatch({
                        type: 'EditPositions',
                    })}
                    onSave={() => dispatch({
                        type: 'SavePositions',
                    })}
                    onDiscard={() => dispatch({
                        type: 'DiscardPositions',
                    })}
                />}
                <div className={classes.tabForm}>
                    <div className={classes.cardHeader}>
                        Positionen
                    </div>
                    <form noValidate={true}>
                        <PositionsTable
                            state={state}
                            dispatch={dispatch}
                        />
                    </form>
                </div>
            </div>
        )
    )

function PositionsTable({state, dispatch}: {
    state: PositionsTab,
    dispatch: (action: PositionsSubAction) => void,
}) {
    const disabled = Editable.inputsDisabled(state.editable)
    return (
        <Table
            style={{marginTop: '16px'}}
        >
            <TableHead>
                <TableRow>
                    <TableCell style={{width: '40%'}}>
                        Name
                    </TableCell>
                    <TableCell>Anzahl</TableCell>
                    <TableCell>
                        Gewicht
                    </TableCell>
                    <TableCell>
                        Preis (netto)
                    </TableCell>
                    <TableCell>Zuordnung</TableCell>
                    <TableCell
                        style={{
                            textAlign: 'center',
                            width: '1%'
                        }}
                    >
                        PDF
                    </TableCell>
                    <TableCell style={{width: '1%'}}>
                        {!disabled && <IconButton
                            tooltip="Position hinzufügen"
                            tooltipPosition={'bottom-left'}
                            onTouchTap={
                                () => dispatch({type: 'AddPosition'})}
                        >
                            <ContentAddBox/>
                        </IconButton>}
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {R.map(
                    positionRow =>
                        <PositionRowElement
                            disabled={disabled}
                            key={positionRow.id}
                            positionRow={positionRow}
                            dispatch={dispatch}
                        />,
                    state.positionRows)}
            </TableBody>
        </Table>)
}

interface PropsPositionRowElement {
    readonly disabled: boolean
    readonly positionRow: PositionRow
    readonly dispatch: (action: PositionsSubAction) => void

}

export const PositionRowElement =
    injectSheet<PropsPositionRowElement>(styles)(
        ({classes, disabled, positionRow, dispatch}) => {
            const
                {input, toBeDeleted} = positionRow
            return (
                <TableRow>
                    <CisTableCell style={{width: '40%'}}>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        <EditableTextField
                            className={classes.tabInput}
                            locked={disabled || toBeDeleted}
                            value={input.name}
                            onChange={(event) => dispatch({
                                type: 'PositionNameChanged',
                                value: event.currentTarget.value,
                                id: positionRow.id
                            })}
                            fullWidth={true}
                            formHelperText={errorMessage(positionRow.validation.name)}
                            error={positionRow.validation.name !== null}
                        />
                    </CisTableCell>
                    <CisTableCell>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        <EditableTextField
                            className={classes.tabInput}
                            locked={disabled || toBeDeleted}
                            value={input.amount}
                            onChange={(event) => dispatch({
                                type: 'PositionAmountChanged',
                                value: event.currentTarget.value,
                                id: positionRow.id
                            })}
                            fullWidth={true}
                            formHelperText={errorMessage(positionRow.validation.amount)}
                            error={positionRow.validation.amount !== null}
                        />
                    </CisTableCell>
                    <CisTableCell numeric={true}>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        <EditableTextField
                            className={classes.tabInput}
                            locked={disabled || toBeDeleted}
                            value={input.weight}
                            onChange={(event) => dispatch({
                                type: 'PositionWeightChanged',
                                value: event.currentTarget.value,
                                id: positionRow.id
                            })}
                            fullWidth={true}
                            formHelperText={errorMessage(positionRow.validation.weight)}
                            error={positionRow.validation.weight !== null}
                        />
                    </CisTableCell>
                    <CisTableCell numeric={true}>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        <EditableTextField
                            className={classes.tabInput}
                            locked={disabled || toBeDeleted}
                            value={input.price}
                            onChange={(event) => dispatch({
                                type: 'PositionPriceChanged',
                                value: event.currentTarget.value,
                                id: positionRow.id
                            })}
                            fullWidth={true}
                            formHelperText={errorMessage(positionRow.validation.price)}
                            error={positionRow.validation.price !== null}
                        />
                    </CisTableCell>
                    <CisTableCell>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        Zuordnung
                    </CisTableCell>
                    <CisTableCell style={{textAlign: 'center'}}>
                        {toBeDeleted && <TableCellGrayOutOverlay/>}
                        <PrintPdfDownloadButton
                            positionRow={positionRow}
                            dispatch={dispatch}
                        />
                    </CisTableCell>
                    <CisTableCell>
                        {!disabled &&
                        <IconButton
                            onTouchTap={() => dispatch({
                                type: 'PositionToBeDeletedToggle',
                                id: positionRow.id,
                                toBeDeleted: !toBeDeleted
                            })}
                        >
                            {toBeDeleted ?
                                <ContentUndo/> :
                                <ActionDelete/>}
                        </IconButton>}
                    </CisTableCell>
                </TableRow>)
        }
    )

function PrintPdfDownloadButton({positionRow, dispatch}: {
    positionRow: PositionRow
    dispatch: (action: PositionsSubAction) => void,
}): JSX.Element {
    const
        productCategoriesWithPrintPdf: ProductCategory[] = [
            'VdpProject',
            'Special',
            'Pod',
            'BulkProject',
        ],
        product =
            (() => {
                switch (positionRow.mode.type) {
                    case 'Editing':
                        return positionRow.mode.positionWithProduct.product
                    case 'Creating':
                        return positionRow.mode.product
                }
            })(),
        active = R.contains(product.category, productCategoriesWithPrintPdf)

    switch (positionRow.printPdfDownload.type) {
        case 'Default': {
            return (
                <FlatButton
                    icon={<ImagePictureAsPdf/>}
                    className="btn-icon"
                    disabled={!active}
                    onTouchTap={() => dispatch({
                        type: 'DownloadPrintPdf',
                        id: positionRow.id,
                    })}
                />)
        }
        case 'Loading': {
            return <CircularProgress size={20}/>
        }
        case 'Failure': {
            return (
                <FlatButton
                    icon={<AlertError/>}
                    className="btn-icon"
                    onTouchTap={() => dispatch({
                        type: 'DownloadPrintPdf',
                        id: positionRow.id,
                    })}
                />)
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/Positions/PositionsView.tsx